import { render, staticRenderFns } from "./PlayBtn.vue?vue&type=template&id=cdd9c11a&scoped=true&"
import script from "./PlayBtn.vue?vue&type=script&lang=js&"
export * from "./PlayBtn.vue?vue&type=script&lang=js&"
import style0 from "./PlayBtn.vue?vue&type=style&index=0&id=cdd9c11a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd9c11a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VProgressCircular,VTooltip})
